export default __webpack_public_path__ + "static/media/083ccfe35e40eb719e0a4051eed4dcc5.png";